import React, { Suspense, useState } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import OurRoutes from './Routes';
import * as Routers from './Routers';
import Header from '../components/header';
import AppSnackbar from '../components/AppSnackbar';
import { CartProvider } from '../context/CartContext';
import { LanguageProvider, useLanguage } from '../context/LanguageContext';
import t from '../utils/translate';

// Wraps the routing logic and header display
const AppRouterWrapper = () => {
  const { language } = useLanguage();
  const [searchFilter, setSearchFilter] = useState({ userId: '', brandId: '' });

  return (
    <div key={language}>
      <AppSnackbar />
      <Header
        searchFilter={searchFilter}
        setSearchFilter={setSearchFilter}
      />

      <Routes>
        <Route path={OurRoutes.LOGIN} element={<Routers.LOGIN />} />
        <Route path={OurRoutes.SIGNUP} element={<Routers.SIGNUP />} />
        <Route
          path={OurRoutes.CREATOR}
          element={
            <Routers.Homepage
              searchFilter={searchFilter}
            />
          }
        />
        <Route path={OurRoutes.DISCOVER} element={<Routers.DISCOVER />} />
        <Route path={OurRoutes.ADDTOCART} element={<Routers.MY_CART />} />
        <Route path={OurRoutes.CHECKOUT} element={<Routers.CHECKOUT />} />
        <Route path={OurRoutes.ADDRESSE} element={<Routers.ADDRESSE />} />
        <Route path={OurRoutes.PRODUCT_DETAILS} element={<Routers.PRODUCT_DETAILS />} />
        <Route path={OurRoutes.DETAILS} element={<Routers.DETAILS />} />
        <Route path={OurRoutes.PROFILE} element={<Routers.PROFILE />} />
        <Route path={OurRoutes.USER_PROFILE} element={<Routers.USER_PROFILE />} />
        <Route path={OurRoutes.USER_PRODUCTS} element={<Routers.USER_PRODUCTS />} />
        <Route path={OurRoutes.ORDER_SUCCESS} element={<Routers.ORDER_SUCCESS />} />
        <Route path={OurRoutes.ORDER_RETURN} element={<Routers.ORDER_RETURN />} />
        <Route path={OurRoutes.ORDER_RETURN_STATUS} element={<Routers.ORDER_RETURN_STATUS />} />
        <Route path={OurRoutes.ORDER_DETAIL} element={<Routers.ORDER_DETAIL />} />
        <Route path={OurRoutes.RETURN_AND_REFUND} element={<Routers.RETURN_AND_REFUND />} />
        <Route path={OurRoutes.STYLES} element={<Routers.STYLES />} />
        <Route path={OurRoutes.SELECTIONS} element={<Routers.SELECTIONS />} />
        <Route path={OurRoutes.LIKED_IMAGES} element={<Routers.STYLES />} />
        <Route path={OurRoutes.LIKED_PRODUCTS} element={<Routers.STYLES />} />
        <Route path={OurRoutes.MY_ACCOUNT} element={<Routers.MY_ACCOUNT />} />
        <Route path={OurRoutes.MY_PROFILE} element={<Routers.MY_PROFILE />} />
        <Route path={OurRoutes.MY_ADDRESS} element={<Routers.MY_ADDRESS />} />
        <Route path={OurRoutes.CHANGE_PASSWORD} element={<Routers.CHANGE_PASSWORD />} />
        <Route path={OurRoutes.FORGOT_PASSWORD} element={<Routers.FORGOT_PASSWORD />} />
        <Route path={OurRoutes.NOTIFY} element={<Routers.NOTIFY />} />
        <Route path={OurRoutes.MY_CART} element={<Routers.MY_CART />} />
        <Route path={OurRoutes.DISCOVER_DETAILS} element={<Routers.DISCOVER_DETAILS />} />
        <Route path={OurRoutes.BRAND_COLLECTION} element={<Routers.BRAND_COLLECTION />} />
      </Routes>
    </div>
  );
};

const AppRouter = () => (
  <LanguageProvider>
    <Router>
      <CartProvider>
        <Suspense fallback={<div>{t("loading")}</div>}>
          <AppRouterWrapper />
        </Suspense>
      </CartProvider>
    </Router>
  </LanguageProvider>
);

export default AppRouter;
